import { graphql } from 'gql.tada';

export const GET_CURRENT_CART = graphql(`
    query getCurrentCart {
        getCurrentCart {
            identifier {
                id
            }
            total
            programs {
                language
                program {
                    identifier {
                        id
                    }
                    titles
                    coverUrl
                    creditRollUrl
                    duration
                    coverImageFile {
                        id
                        tenantId
                        tenant {
                            cloudFrontUrl
                        }
                    }
                    audioLanguages
                    masterSubtitles {
                        language
                    }
                    price
                    firstBroadcastDate
                    parent {
                        identifier {
                            id
                        }
                        titles
                        coverImageFile {
                            id
                            tenantId
                            tenant {
                                cloudFrontUrl
                            }
                        }
                    }
                    episodeNumber
                    episodesQuantity
                }
            }
        }
    }
`);

export const UPDATE_CART = graphql(`
    mutation updateCart(
      $id: UUID!, 
      $programs: CartPrograms
    ) {
        updateCart(
          id: $id,
          programs: $programs,
        ) {
          identifier {
            id
            sku
          }
      }
    }
`);
